export default __webpack_public_path__ + "static/about-4-00886368ce8d984718728324593c0b84.webp";